<template >
    
    <div class="col-md-4 border-right-custom div-diemension">
        
        <div  v-for="(user, index) in users" :class="['row border-bottom',{'active_chat': index===activeUserindex}]"   @click="changeUser(user,index)">
            <div class="col-md-2 " >

                <img alt="User Pic" v-if="user.send_to_user.basic_profile && user.send_to_user.basic_profile.profile_picture!=null" :src="user.send_to_user.basic_profile.profile_picture" id="profile-image1" class="img-circle img-responsive" style="border-radius:50%; width: 40px;height: 40px"> 
                <img alt="User Pic" v-else src="/assets/images/default.png" id="profile-image1" class="img-circle img-responsive" style="border-radius:50%; width: 40px;height: 40px"> 
                
                <span :class="user.send_to_user.is_session_active ? 'online_icon': 'offline'"></span>
            </div>

            <div class="col-md-6 mobile-view-middile-section">
                <b class="user-font-size">{{user.send_to_user.first_name}} {{user.send_to_user.last_name}}</b><br/>
                <a v-if="user.module"
                   class="user-font-size"
                   :href="moduleLink(user)">
                    {{user.module.title}}
                </a>
                
            </div>

            <div class="col-md-4 mobile-view-last-section">
                <span class="user-font-size" v-if="user.send_to_user.last_login_at">{{formattedDate(user.send_to_user.last_login_at)}}</span></br>
                <a v-if="user.module"
                   :href="moduleLink(user)"
                   :class="user.model_color"
                   style="text-decoration: none; color: white;">
                    {{user.model}}
                </a>
                <span v-else :class="user.model_color">{{user.model}}</span>

            </div>

        </div>
        <div v-if="!users.length">
            

            <div class="col-md-12 text-center mt-5">
                
                <strong> No Active User </strong>
                
            </div>
            
            <br>
            
        </div>


       

    </div>
 
</template>

<script>
    import moment from 'moment';    
    export default {
       
        data(){  
            return {  
                activeUserindex:0,
            };  
        },
        props: {

            users: Array,
        },
        watch: { 
            users: function(newVal, oldVal) { // watch it
                this.activeUserindex=0;
            },
           
        },
        methods: {
            formattedDate(date)
            {
                if (!date) {
                    return '';
                }

                return moment.utc(String(date)).local().format('MM/DD/YYYY hh:mm');
            },
            moduleLink(user){
                if(!user.module || !user.module.uuid) return '#';

                if(user.model === 'Service') return `/service/details/${user.module.uuid}`;
                if(user.model === 'Software') return `/software/details/${user.module.uuid}`;

                return `/job/single-job/${user.module.uuid}`;
            },
            changeUser(user,index)
            {
                this.activeUserindex=index;
                this.$emit('userChange',user);
            }

        },
        mounted() {
            console.log('Component mounted.')
        }
    }
</script>
<style scoped>

.active_chat{
    background-color: rgba(0,0,0,.03);
}
.div-diemension{
    max-height: 660px;
    min-height: 660px;
    overflow: overlay;
}
.online_icon{
    position: relative;
    height: 10px;
    width: 10px;
    background-color: #4cd137;
    border-radius: 50%;
    border: 1.5px solid white;
    left: 28px;
    top: -20px;
}
.offline{
    position: relative;
    height: 10px;
    width: 10px;
    background-color: #c23616;
    border-radius: 50%;
    border: 1.5px solid white;
    left: 29px;
    top: -20px;
}
    .user-font-size{
        font-size: 12px;
    }
    .border-bottom{
        
        padding-top: 7px;
        cursor: pointer;
     
    }
    .border-right-custom{
        border-right: 1px solid #DEE7E7;
        
    }
    .row {
        --bs-gutter-x: 1.5rem;
        --bs-gutter-y: 0;
        display: flex;
        flex-wrap: wrap;
        margin-top: calc(var(--bs-gutter-y) * -1);
        margin-right: -12px !important;
        margin-left: -24px !important;
    }
     @media only screen and (max-width:683px){
        .div-diemension{
            max-height: 660px !important;
            min-height: 250px !important;
            overflow: overlay !important;
        }
        .offline[data-v-ef8bd22e] {
            position: relative;
            height: 10px;
            width: 10px;
            background-color: #c23616;
            border-radius: 50%;
            border: 1.5px solid white;
            left: -14px !important;
            top: -14px !important;
        }
        .mobile-view-middile-section{
            padding-left: 67px !important;
            margin-top: -45px !important;
            width: 249px !important;
        }
        .mobile-view-last-section{
            padding-left: 223px !important;
            margin-top: -54px !important;
        }
    }


</style>
